<script lang="ts">
    import { setTypedContext } from "@lib/svelte-typed-context";

    import { modalManagerContextKey } from "./constants";
    import { ModalManager } from "./ModalManager";

    export let modalManager: ModalManager;
    setTypedContext(modalManagerContextKey, modalManager);
</script>

<slot />
